import "react-image-lightbox/style.css";

import { Button, TextField } from "@mui/material";
import { Card, Col, Container, Row } from "react-bootstrap";
import React, { Fragment, useEffect, useState } from "react";
import {
  fetchActiveReceipt,
  fetchDeactiveReceipt,
  fetchReRejectReceipt,
  fetchReactiveReceipt,
  fetchReceiptList,
} from "../actions/receipt";
import { formatDateFull, formatOnlyDate } from "../utils";
import { useNavigate, useParams } from "react-router-dom";

import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import CustomModal from "../components/Common/Modal/CustomModal";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import FormTitleMain from "../components/Admin/Reusable/FormTitleMain";
import Lightbox from "react-image-lightbox";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const OrderDetail = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isLightboxOpen, setIsLightboxOpen] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState("");
  const [typeAction, setTypeAction] = useState("");
  const [rejectReason, setRejectReason] = useState("");

  const { receiptDetail } = useSelector((state) => state.receiptReducer);

  //breadcrumb
  const translateForm = "orderForm";
  const translateModule = "Detail";
  const pageType = id ? "Edit" : "Add";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  const orderConfirmation = (type) => {
    setTypeAction(type);
    setShowModal(true);
    setTitleModal(t("orderDetail.modal.title"));
  };

  const orderConfirmationAgain = (type) => {
    setTypeAction("reapprove");
    setShowModal(true);
    setTitleModal(t("orderDetail.modal.title"));
  };

  const modalCloseHandler = () => {
    setShowModal(false);
  };

  const handleSubmit = () => {
    if (typeAction === "reject" && rejectReason === "") {
      toast.error("Morate uneti razlog odbijanja prodaje", {
        theme: "colored",
      });
      return;
    }

    const item = {
      rejectReason: rejectReason,
    };

    // typeAction == "reject"
    //   ? dispatch(fetchDeactiveReceipt(id, item, navigate))
    //   : dispatch(fetchActiveReceipt(id, navigate));

    switch (typeAction) {
      case "reject": {
        const item = {
          rejectReason: rejectReason,
        };
        dispatch(fetchDeactiveReceipt(id, item, navigate));
        break;
      }

      case "rereject": {
        const item = {
          rejectReason: rejectReason,
        };
        dispatch(fetchReRejectReceipt(id, item, navigate));
        break;
      }

      case "approve": {
        dispatch(fetchActiveReceipt(id, navigate));
        break;
      }

      case "reapprove": {
        dispatch(fetchReactiveReceipt(id, navigate));
        // ili fetchReapproveReceipt ako imaš poseban endpoint
        break;
      }

      default:
        break;
    }
  };

  useEffect(() => {
    dispatch(fetchReceiptList(id));
  }, [dispatch, id]);

  const statusName =
    receiptDetail?.status === "PENDING"
      ? "<span class='text-warning-info'>Na čekanju</span>"
      : receiptDetail?.status === "APPROVED"
      ? "<span class='text-success-info'>Odobreno</span>"
      : "<span class='text-danger-info'>Odbijeno</span>";

  return (
    <Fragment>
      <Breadcrumb
        breadcrumbItems={breadcrumbItems}
        type={translateModule}
        id={id}
        extraTitle={receiptDetail?.receiptNumber}
        pageType={pageType}
      />
      <Container>
        <Row>
          <Col lg={12}>
            {receiptDetail?.status !== "APPROVED" &&
              receiptDetail?.status !== "REJECTED" && (
                <Row>
                  <Col lg={12}>
                    <div className="text-end mb-2">
                      <Button
                        variant="contained"
                        color="info"
                        className="mr-2"
                        size="small"
                        startIcon={<CheckCircleOutlineOutlinedIcon />}
                        onClick={() => orderConfirmation("approve")}
                      >
                        {t("orderConfirmation.approve")}
                      </Button>
                      <Button
                        variant="contained"
                        color="error"
                        size="small"
                        startIcon={<CloseOutlinedIcon />}
                        onClick={() => orderConfirmation("reject")}
                      >
                        {t("orderConfirmation.reject")}
                      </Button>
                    </div>
                  </Col>
                </Row>
              )}
            {receiptDetail?.status == "REJECTED" && (
              <Row>
                <Col lg={12}>
                  <div className="text-end mb-2">
                    <Button
                      variant="contained"
                      color="info"
                      className="mr-2"
                      size="small"
                      startIcon={<CheckCircleOutlineOutlinedIcon />}
                      onClick={() => orderConfirmationAgain("approve")}
                    >
                      {t("orderConfirmation.approve")}
                    </Button>
                  </div>
                </Col>
              </Row>
            )}
            {/*{receiptDetail?.status == "APPROVED" && (*/}
            {/*  <Row>*/}
            {/*    <Col lg={12}>*/}
            {/*      <div className="text-end mb-2">*/}
            {/*        <Button*/}
            {/*          variant="contained"*/}
            {/*          color="error"*/}
            {/*          size="small"*/}
            {/*          startIcon={<CloseOutlinedIcon />}*/}
            {/*          onClick={() => orderConfirmation("rereject")}*/}
            {/*        >*/}
            {/*          {t("orderConfirmation.reject")}*/}
            {/*        </Button>*/}
            {/*      </div>*/}
            {/*    </Col>*/}
            {/*  </Row>*/}
            {/*)}*/}
            <Row>
              <Col lg={9}>
                <Card>
                  <Card.Header>
                    <FormTitleMain />
                  </Card.Header>
                  <Card.Body>
                    <div className="order-detail-item">
                      {t("orderDetail.status")}:{" "}
                      <span
                        dangerouslySetInnerHTML={{ __html: statusName }}
                      ></span>
                    </div>
                    <div className="order-detail-item">
                      {t("orderDetail.originalReceiptNumber")}:{" "}
                      <b>{receiptDetail?.receiptNumber}</b>
                    </div>
                    {receiptDetail?.receiptCopyNumber && (
                      <div className="order-detail-item">
                        {t("orderDetail.receiptCopyNumber")}:{" "}
                        <b>{receiptDetail?.receiptCopyNumber}</b>
                      </div>
                    )}
                    <div className="order-detail-item">
                      {t("orderDetail.dateOnReceipt")}:{" "}
                      <b>{formatDateFull(receiptDetail?.dateOnReceipt)}</b>
                    </div>
                    {receiptDetail?.dateOnReceiptCopy && (
                      <div className="order-detail-item">
                        {t("orderDetail.dateOnReceiptCopy")}:{" "}
                        <b>
                          {formatDateFull(receiptDetail?.dateOnReceiptCopy)}
                        </b>
                      </div>
                    )}
                    <div className="order-detail-item">
                      {t("orderDetail.creationDate")}:{" "}
                      <b>{formatDateFull(receiptDetail?.createdAt)}</b>
                    </div>
                    {receiptDetail?.updatedAt && (
                      <div className="order-detail-item">
                        {t("orderDetail.lastUpdateDate")}:{" "}
                        <b>{formatDateFull(receiptDetail?.updatedAt)}</b>
                      </div>
                    )}
                    {receiptDetail?.rejectReason && (
                      <div className="order-detail-item">
                        {t("orderDetail.rejectReason")}: <br />
                        <b>{receiptDetail?.rejectReason}</b>
                      </div>
                    )}
                    <table className="table table-bordered table-striped mt-3">
                      <thead>
                        <tr>
                          <th>{t("orderDetail.product")}</th>
                          <th>{t("orderDetail.quantity")}</th>
                          <th>{t("orderDetail.totalPoints")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {receiptDetail?.items?.map((item, key) => (
                          <tr key={key}>
                            <td>{item?.productName}</td>
                            <td>{item?.quantity}</td>
                            <td>{item?.points}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </Card.Body>
                </Card>
              </Col>
              <Col lg={3}>
                <Card>
                  <Card.Header>
                    <h6 className="mb-0">{t("awardForm.image")}</h6>
                  </Card.Header>
                  <Card.Body>
                    <img
                      src={receiptDetail?.receiptImage}
                      alt="receiptImage"
                      style={{ width: "100%", cursor: "pointer" }}
                      className="mb-2"
                      onClick={() => setIsLightboxOpen(true)}
                    />

                    <Button
                      variant="contained"
                      color="info"
                      className="w-100"
                      size="small"
                      startIcon={<FileDownloadOutlinedIcon />}
                      onClick={() =>
                        window.open(receiptDetail?.receiptImage, "_blank")
                      }
                    >
                      Preuzmi sliku
                    </Button>

                    {isLightboxOpen && (
                      <Lightbox
                        mainSrc={receiptDetail?.receiptImage}
                        onCloseRequest={() => setIsLightboxOpen(false)}
                      />
                    )}
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
      {showModal && (
        <CustomModal
          show={showModal}
          hideModal={modalCloseHandler}
          modalTitle={titleModal}
          actionSubmitModal={() => handleSubmit()}
        >
          {typeAction === "reject" || typeAction === "rereject" ? (
            <Fragment>
              <span>
                {t("orderDetail.modal.rejectConfirmation")}{" "}
                <b>{receiptDetail?.receiptNumber}</b>?
              </span>
              <TextField
                id="outlined-multiline-flexible"
                label={t("orderDetail.modal.rejectReasonLabel")}
                multiline
                required
                className="mt-4"
                rows={4}
                variant="outlined"
                fullWidth
                name="rejectReason"
                value={rejectReason}
                onChange={(e) => setRejectReason(e.target.value)}
              />
            </Fragment>
          ) : (
            <span>
              {t("orderDetail.modal.acceptConfirmation")}{" "}
              <b>{receiptDetail?.receiptNumber}</b>?
            </span>
          )}
        </CustomModal>
      )}
    </Fragment>
  );
};

export default OrderDetail;
